import { useMemo } from "react";
import { useGetClientQuery } from "@/queries/useGetClientQuery";

export const useAvatarProfile = () => {
  const { data: clientData, isPending, error } = useGetClientQuery();

  const firstLetter: string = useMemo(() => {
    if (clientData) return `${clientData.name.charAt(0).toUpperCase()}`;
    return "";
  }, [clientData]);

  if (isPending)
    return {
      firstLetter: "Г",
    };

  if (error)
    return {
      firstLetter: "X",
    };
  return {
    firstLetter,
  };
};
